var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26 ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4262",
    "data-name": "Grupo 4262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4145",
    "data-name": "Grupo 4145"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_60",
    "data-name": "Elipse 60",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(0 26) rotate(-90)",
    fill: "#f00909"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3272",
    "data-name": "Caminho 3272",
    d: "M0,0V12",
    transform: "translate(17 8.5) rotate(45)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3271",
    "data-name": "Caminho 3271",
    d: "M0,0H12",
    transform: "translate(9 8.5) rotate(45)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRed);
export default __webpack_public_path__ + "static/media/Error_red.d609df44.svg";
export { ForwardRef as ReactComponent };